import { navigateInternally } from 'utils/bolt';

export function maybeNavInternally(e) {
	let link = e.target.closest('a');
	if (!link) {
		return;
	}
	let href = link.getAttribute('href');
	if (href.startsWith('#$')) {
		e.preventDefault();
		let page = href.slice(2).trim();
		let navOptions = {};
		if (page.includes('/?')) {
			let [pageId, qs] = page.split('/?');
			page = pageId;
			navOptions.queryString = '?' + qs;
		}
		navigateInternally(page, navOptions);
	}
}